module.exports = __webpack_public_path__ + "img/medicalapp_typography.cdc27f42.webp";